<ul class="psc-list" *transloco="let t">
  <li *ngFor="let rule of rules" class="psc-item" [class.psc-item--met]="rule.met">
    <span class="psc-dot" aria-hidden="true"></span>
    <span class="psc-label">{{ t(rule.labelKey) }}</span>
  </li>
</ul>
